import axios from "axios";

/* templates */
import { newsItem } from './../templates/news.js';

/** ----------------------------------------
     News
 ---------------------------------------- */

export class News {

    constructor(host) {
        this.count = 5;
        this.done = false;
        this.host = host;
        this.more = '';
        this.init();
    }

    /** ----------------------------------------
         Listen
     ---------------------------------------- */

    listen() {
        this.more = document.querySelector('.js-load-more');

        this.more.addEventListener('click', () => {
            this.feed(this.count);
            this.resolve();
        });
    }

    remove() {
        this.more.remove();
    }

    /** ----------------------------------------
         Set Results
     ---------------------------------------- */

    set(data) {
        let container = document.getElementById('js-news-results');
        let theme = document.body.dataset.theme;

        data.map(item => {
            let html = newsItem(item, theme, this.host);
            container.insertAdjacentHTML('beforeend', html);
        });
    }

    check() {
        let url = this.host.path + '/feed/' + this.host.info.language + '/news/' + (this.count + 5);

        return axios.get(url)
            .then(result => {
                return result.data.length !== 0;
            });
    }

    resolve() {
        let resolve = new Promise((resolve) => {
            resolve(this.check());
        });

        resolve.then((moreNews) => {
            if (!moreNews) {
                this.done = true;
                this.remove();
            }
        });
    }

    /** ----------------------------------------
        Feed
     ---------------------------------------- */

    feed(amount) {
        let url = this.host.path + '/feed/' + this.host.info.language + '/news/' + amount;

        axios.get(url)
            .then(result => {
                if(result.data)
                    this.count = this.count + 5;
                    this.set(result.data);
            });
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    init() {
        let template =  document.body.dataset.template;

        if(template !== 'news')
            return;

        this.listen();
    }

}

